import getWallet from "./wallet";
import abi from "../abi/xGold.json";
import ownerAbi from "../abi/owner.json";
import busoAbi from "../abi/buso.json";
import autolp from "../abi/autolp.json";
import tokenAbi from "../abi/token.json";
import { ethers } from "ethers";

// Polygon Mainnet
const proxyContract = "0x79Dc1B7f836D956c3cb679EbA79EE9eC99613eDA";
const ownerContract = "0x524D866cb919FEa48BD000c0C8f5F9447dbd3fcB";
const marketingWallet = "0x09dFe41E7184F02cb6621C8c2e692A2C7730b94e";

// Mumbai
// export const proxyContract = "0xC66443F6a4DFe3A45c1D65f7c9797F75cc6A9df3";
// export const ownerContract = "0x1636A4EA655542B4584832ffcF96b09eB92Eb7C4";

const contractCreationBlockNumber = 36878957;

const getContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(proxyContract, abi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    
    return contract;
}

export const getContractCreationBlock = async () => {
    return contractCreationBlockNumber;
}

export const getTotalContractTransactions = async () => {
    try {
      const wallet = await getWallet();
      const transactionCount = await wallet.provider.getTransactionCount(proxyContract);
      console.log("transactionCount: ", transactionCount);
      return transactionCount;
    } catch (error) {
      throw new Error('Failed to retrieve total contract transactions: ' + error.message);
    }
  };

// export const getAutoLpContract = async () => {
//     const wallet = await getWallet();
//     let contract = new ethers.Contract(autoLp, autolp, wallet.provider);
//     if (!wallet.isReadOnly) {
//         contract = contract.connect(wallet.signer);
//     }
//     return contract;
// }

export const getOwnerContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(ownerContract, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

export const getMarketingContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(marketingWallet, ownerAbi, wallet.provider);
    if (!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

const token = "0xD69071579ae36c45D63EC2D5d0E82C0a569c2cC3";

export const getTokenContract = async () => {
  const wallet = await getWallet();
  let contract = new ethers.Contract(token, tokenAbi, wallet.provider);
  if (!wallet.isReadOnly) {
      contract = contract.connect(wallet.signer);
  }
  return contract;
}


export default getContract;